import { Link } from "react-router-dom";

const CdeDetailsLink = ({ associatedCDE, reportType, crfId, domainName, subDomainName, crfName }) => {
  return (
    <>
      {associatedCDE ? (
        <Link
          to={`/curesickle/cde-details/${reportType}/${crfId
            }/${domainName.replace(/\//g, "-")}/${subDomainName.replace(
              /\//g,
              "-"
            )}/${crfName.replace(/\//g, "-")}`}
        >
          CDE Details
        </Link>
      ) : (
        "N/A"
      )}
    </>
  );
};

export default CdeDetailsLink;